import Swiper, { Autoplay } from 'swiper';

const formSecArr = document.querySelectorAll('.form-sec');
if (formSecArr.length) {
  formSecArr.forEach((formSecEl) => {
    const filtersSwiperWr = formSecEl.querySelector('.filters-swiper-wr');
    const filtersItemsArr = filtersSwiperWr?.querySelectorAll('.form-sec__filter');

    const formsContainerEl = formSecEl.querySelector('.form-sec__forms-container');
    const formContainerElsArr = formsContainerEl?.querySelectorAll('.form-sec__form-container');

    if (filtersSwiperWr) {
      let swiperEl = filtersSwiperWr.querySelector('.swiper');
      let slidesCount = filtersSwiperWr.querySelectorAll('.swiper-slide').length;
      let wrapper = swiperEl.querySelector('.swiper-wrapper');
      let swiper = new Swiper(swiperEl, {
        modules: [Autoplay],
        observer: true,
        observeParents: true,
        spaceBetween: 16,
        slidesPerView: 'auto',
        threshold: 10,
        breakpoints: {
          640: {
            spaceBetween: 20,
          },
          1024: {
            spaceBetween: 30,
          },
          1200: {
            spaceBetween: 40,
          },
          1400: {
            spaceBetween: 77,
          },
        },
      });
    }

    if (filtersItemsArr?.length && formContainerElsArr?.length) {
      filtersItemsArr.forEach((filterItemEl, idx) => {
        filterItemEl.addEventListener('click', (e) => {
          filtersItemsArr.forEach((_, index) => {
            filtersItemsArr[index].classList.remove('is-active');
            formContainerElsArr[index].classList.remove('is-active');
          });

          filterItemEl.classList.add('is-active');
          formContainerElsArr[idx].classList.add('is-active');
        });
      });
    }
  });
}